import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M11.28 100.5H54.98C54.98 100.5 61.65 79.7899 62 44.6899C62.35 9.58994 59.54 1.33997 59.54 1.33997H7.94004C7.94004 1.32997 -7.67996 52.41 11.28 100.5Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
